import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getVMSService = async (site_uuid, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("vms")
      .select()
      .eq("site_uuid", site_uuid);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching VMS data:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getVMSService:", error);
    return null;
  }
};

export const getVMSTodayService = async (site_uuid, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("vms")
      .select()
      .eq("site_uuid", site_uuid);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    } else {
      // ถ้าไม่มี date range ให้ใช้วันปัจจุบัน
      let currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 7);
      let isoString = currentDate.toISOString();
      query = query.gte("created_at", isoString.split("T")[0]);
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching VMS today data:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getVMSTodayService:", error);
    return null;
  }
};

export const getVMSDestinationService = async (site_uuid, destination, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("vms")
      .select()
      .eq("site_uuid", site_uuid)
      .eq("destination", destination);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    } else {
      // ถ้าไม่มี date range ให้ใช้วันปัจจุบัน
      let currentDate = new Date();
      currentDate.setHours(currentDate.getHours() + 7);
      let isoString = currentDate.toISOString();
      query = query.gte("created_at", isoString.split("T")[0]);
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching VMS destination data:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getVMSDestinationService:", error);
    return null;
  }
};

export const getVMSNotExitService = async (site_uuid, startDate = null, endDate = null) => {
  try {
    let query = supabase
      .from("vms")
      .select()
      .eq("site_uuid", site_uuid)
      .is("exit_datetime", null);
    
    if (startDate && endDate) {
      query = query
        .gte("created_at", startDate)
        .lte("created_at", endDate + "T23:59:59");
    }
    
    const { data, error } = await query.order("id", { ascending: false });
    
    if (error) {
      console.error("Error fetching VMS not exit data:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in getVMSNotExitService:", error);
    return null;
  }
};

export const stampExitService = async (vms_uuid) => {
  try {
    let currentDate = new Date();
    // currentDate.setHours(currentDate.getHours() + 7);
    let isoString = currentDate.toISOString();
    const { data, error } = await supabase
      .from("vms")
      .update({ exit_datetime: isoString, exit_name: "ยืนยันการออกพื้นที่โดย Admin" })
      .eq("vms_uuid", vms_uuid);
    
    if (error) {
      console.error("Error stamping exit:", error);
      return null;
    }
    
    return data;
  } catch (error) {
    console.error("Error in stampExitService:", error);
    return null;
  }
};
